import { FREEDOM } from '../../constants';

export const getLinkedLocationOptions = (model, locationOptions) => {
  if (!model || !locationOptions) return [];
  const linkedLocationIds =
    model.linkedLocationIds ||
    Object.keys(model.features || {}).filter(key => model.features[key]);
  return locationOptions.filter(locationOption =>
    linkedLocationIds.includes(locationOption.locationId),
  );
};

export default class ModelsOptions {
  constructor(data) {
    this.models = [];
    if (data && data.fields) {
      const { phoneModelsOrder } = data.fields;
      phoneModelsOrder.forEach(phoneModel => {
        if (phoneModel && phoneModel.fields) {
          const {
            name,
            manufacturer,
            freedomModel,
            internationalModel,
            otherCanModel,
            unknownModel,
            usaModel,
            tags,
          } = phoneModel.fields;
          const isShawDevice = tags?.some(tag => tag.fields.tag === FREEDOM);
          if (!isShawDevice) return;
          const model = {};
          model.brand =
            manufacturer && manufacturer.fields && manufacturer.fields.name;
          model.modelName = name;
          model.features = {
            freedomModel,
            internationalModel,
            otherCanModel,
            unknownModel,
            usaModel,
          };
          model.linkedLocationIds = Object.keys(model.features).filter(
            key => model.features[key],
          );
          this.models.push(model);
        }
      });
    }
  }
}
